import React from 'react';
import clsx from 'clsx';
import InputCheckbox from 'pages/Dashboard/components/Input/Checkbox';
import FormFieldInlineLabel from 'views/EMR/components/FillableForm/components/FormFieldInlineLabel';
import {
  FieldComponentProps,
} from 'views/EMR/components/FillableForm/types';

export default function Checkbox({
  field,
  value,
  onChange,
  error = false,
}: FieldComponentProps) {
  return (
    <InputCheckbox
      id={field?.id ?? 'checkbox'}
      checked={Boolean(value?.value)}
      classes={{
        label: clsx({ '!text-red-500': error }),
        checkbox: clsx({ '!text-red-500': error }),
      }}
      label={(
        <FormFieldInlineLabel
          name={field?.name}
          isRequired={field?.isRequired}
          type={field?.type}
          className={clsx('font-semibold', { '!text-red-500': error })}
        />
      )}
      onChange={(checked) => {
        onChange?.({ ...value, value: checked });
      }}
    />
  );
}
